<template lang="html">
  <modal :show="show" @close="close">
    <article class="entry-form" @click.stop>
			<h2 class="visually-hidden">Форма входа</h2>
			<div class="entry-form-switcher">
				<input class="radio-input visually-hidden"
				       type="radio"
				       name="modal_type"
				       id="sign-in"
				       value="login"
				       v-model="modalTypeOption"
				       v-on:change="changeModalType"
				       :checked="modalType == 'login'">
				<label class="entry-form-switcher__sign-in" for="sign-in">Войти</label>

				<input class="radio-input visually-hidden"
				       type="radio"
				       name="modal_type"
				       id="sign-up"
				       value="register"
				       v-model="modalTypeOption"
				       v-on:change="changeModalType"
				       :checked="modalType == 'register'">
				<label class="entry-form-switcher__sign-up" for="sign-up">Регистрация</label>
			</div>

			<article class="sign-in" v-if="modalType == 'login'">
				<h2 class="visually-hidden">Форма входа в аккаунт</h2>

        <section class="login-form-slogan">
					<h3 class="visually-hidden">Слоган школы</h3>
					<div class="entry-form-header">
						<img src="/images/ui/modal-entry/entry-form-header-logo.png" width="62" height="62" alt="Эмблема школы">
						<h6>Школа<br> перинатальной медицины и <br>репродуктивного здоровья</h6>
					</div>
					<img class="login-form-slogan__back" src="/images/ui/modal-entry/back-login-slogan-book.png" width="147" height="135" alt="Изображение книги">
					<p class="login-form-slogan__slogan">Проходите курсы,<br> повышайте уровень своих<br> знаний.</p>
				</section>

        <section class="login-form">
					<form class="login-form__form" @submit.prevent="login" @keydown="loginForm.onKeydown($event)">

						<label class="login-label">{{ $t('email') }}
              <input v-model="loginForm.email"
                     type="email"
                     name="email"
                     v-validate="'required|email'"
                     :class="{'is-danger': errors.has('email') }"
                     class="login-form-grey"
                     placeholder="Введите свое имя" required>
              <span v-show="loginError" class="danger-message">{{ $t('auth_error') }} <br> {{ $t('auth_error_details') }}</span>
              <span v-show="errors.has('email')" class="danger-message">{{ errors.first('email') }}</span>
						</label>
						<label class="login-label" v-if="!changePasswordMode">{{ $t('password') }}
              <input v-model="loginForm.password"
                     type="password"
                     name="password"
                     v-validate="'required|min:6'"
                     :class="{'is-danger': errors.has('password') }"
                     class="login-form-grey"
                     placeholder="******"
                     required>
              <span v-show="errors.has('password')" class="danger-message">{{ errors.first('password') }}</span>
						</label>
						<span class="login-form-grey">{{ $t('forgot_password') }}</span>
						<a href="javascript:void(0)" @click.prevent="changePasswordMode = !changePasswordMode" class="white-underline">
						  {{ $t(changePasswordMode ? 'cancel' : 'change_password') }}
						</a>

						<div class="login-form-flex-container">
              <input :disabled="loginForm.busy" type="submit" class="login-form__enter" :value="$t(changePasswordMode ? 'change_password' : 'login')">
							<input class="visually-hidden checkbox-input"
							       type="checkbox"
							       name="remember-user"
							       v-model="remember"
                     v-if="!changePasswordMode"
							       id="remember-user">
							<label class="checkbox-styled login-form-grey" v-if="!changePasswordMode" for="remember-user">{{ $t('remember_me') }}</label>
						</div>
					</form>
					<div class="login-form__footer" style="display: none">
						<span class="login-form-grey">{{ $t('login_with') }}</span>
						<ul class="login-form__social">
							<li>
								<a class="social-link" v-if="vkAuth" href="/oauth/vkontakte" title="Вконтакте">
									<img src="/images/ui/modal-entry/entry-form-vk-logo.png" width="28" height="16" alt="Вконтакте">
								</a>
							</li>
							<li>
								<a class="social-link" v-if="facebookAuth" href="/oauth/facebook"  title="Фейсбук">
									<img src="/images/ui/modal-entry/entry-form-fb-logo.png" width="13" height="22" alt="Фейсбук">
								</a>
							</li>
							<li>
								<a class="social-link" v-if="twitterAuth" href="/oauth/twitter" title="Твиттер">
									<img src="/images/ui/modal-entry/entry-form-tw-logo.png" width="22" height="18" alt="Твиттер">
								</a>
							</li>
							<li>
								<a class="social-link" v-if="odnoklassnikiAuth" href="/oauth/odnoklassniki" title="Одноклассники">
									<img src="/images/ui/modal-entry/entry-form-ok-logo.png" width="14" height="22" alt="Одноклассники">
								</a>
							</li>
						</ul>
					</div>
				</section>
			</article>

			<article class="registry" v-if="modalType == 'register'">

				<h2 class="visually-hidden">Форма регистрации нового пользователя</h2>
				<form class="registry-form__form" @submit.prevent="register" @keydown="registerForm.onKeydown($event)">
          <input class="visually-hidden" type="text" name="username">
					<section class="registry__slide-company" v-show="registerSlide == 0">

						<h3 class="visually-hidden">Форма регистрации, первый слайд</h3>
						<section class="registry-form-slogan">
							<h4 class="visually-hidden">Информация об учреждении</h4>
							<div class="entry-form-header">
								<img src="/images/ui/modal-entry/entry-form-header-logo.png" width="62" height="62" alt="Эмблема школы">
								<h6>Школа<br> перинатальной медицины и <br>репродуктивного здоровья</h6>
							</div>
							<img class="registry-form-slogan__back" src="/images/ui/modal-entry/back-registry-slogan-university.png" width="143" height="143" alt="Изображение университета">
							<p class="registry-form-slogan__slogan">Информация<br> об учреждении</p>
							<ul class="registry-form-slogan__switcher-indicator">
								<li class="registry-form-slogan__switcher-indicator-active"></li>
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
							</ul>
						</section>

						<section class="registry-form registry-form--company">
							<h4 class="visually-hidden">Поля формы регистрации</h4>
							<label class="login-label">{{ $t('city') }}
                <v-select v-model="registerForm.city"
                          :options="citySuggestions"
                          @search="getCitySuggestions"
                          class="login-form-grey"
                          placeholder="Введите название своего города"
                          v-validate="'required'"
                          required
                ></v-select>

<!--								<input v-model="registerForm.city"-->
<!--								       class="login-form-grey"-->
<!--								       v-validate="'required'"-->
<!--								       :class="{'is-danger': errors.has('city') }"-->
<!--								       type="text"-->
<!--								       autocomplete="off"-->
<!--								       name="city"-->
<!--								       placeholder="Введите название своего города"-->
<!--								       required />-->
<!--								<ul class="login-label__suggestions input-suggestions" v-if="suggestions['city'].length > 0">-->
<!--								  <li v-for="suggestion in suggestions['city']"-->
<!--								      class="input-suggestions__item"-->
<!--								      @click.prevent="selectCity(suggestion)">{{ suggestion }}</li>-->
<!--                </ul>-->
                <span v-show="errors.has('city')" class="danger-message">{{ errors.first('city') }}</span>
                <has-error :form="registerForm" field="city"></has-error>
							</label>
							<label class="login-label">{{ $t('country') }}
								<input v-model="registerForm.country"
								       class="login-form-grey"
								       v-validate="'required'"
								       :class="{'is-danger': errors.has('country') }"
								       type="text"
								       name="country"
								       placeholder="Введите страну проживания"
								       required>
                <span v-show="errors.has('country')" class="danger-message">{{ errors.first('country') }}</span>
							</label>
							<label class="login-label">{{ $t('organization') }}
                <input v-model="registerForm.organization"
                         class="login-form-grey"
                         autocomplete="off"
								         v-validate="'required'"
								         :class="{'is-danger': errors.has('organization') }"
                         type="text"
                         name="organization"
                         placeholder="Где Вы работаете?"
                         required>
                <span v-show="errors.has('organization')" class="danger-message">{{ errors.first('organization') }}</span>
							</label>
							<button class="registry-form__form-next" type="button"
							        value="next-page" :disabled="checkStep0" @click.prevent="nextStep()">Далее</button>
							<span class="login-form-grey">Уже зарегистрированы?</span>
							<a class="white-underline" href="#" @click.prevent="showLogin()">Войти</a>
						</section>
					</section>

					<section class="registry-slide__personal-info" v-show="registerSlide == 1">
						<h3 class="visually-hidden">Форма регистрации, второй слайд</h3>
						<section class="registry-form-slogan">
							<h4 class="visually-hidden">Личная информация</h4>
							<div class="entry-form-header">
								<img src="/images/ui/modal-entry/entry-form-header-logo.png" width="62" height="62" alt="Эмблема школы">
								<h6>Школа<br> перинатальной медицины и <br>репродуктивного здоровья</h6>
							</div>
							<img class="registry-form-slogan__back" src="/images/ui/modal-entry/back-registry-slogan-avatar.png" width="157" height="169" alt="Изображение аватара">
							<p class="registry-form-slogan__slogan">Личная<br> информация</p>
							<ul class="registry-form-slogan__switcher-indicator">
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
								<li class="registry-form-slogan__switcher-indicator-active"></li>
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
							</ul>
						</section>
						<section class="registry-form registry-form--personal-info">
							<h4 class="visually-hidden">Поля формы регистрации</h4>
							<label class="login-label">{{ $t('second_name') }}
								<input v-model="registerForm.second_name"
								       class="login-form-grey"
                       v-validate="'required|min:2|max:100'"
								       :class="{'is-danger': errors.has('second_name') }"
								       type="text"
								       name="second_name"
								       placeholder="Петров"
								       required>
                <span v-show="errors.has('second_name')" class="danger-message">{{ errors.first('second_name') }}</span>
							</label>
							<label class="login-label">{{ $t('first_name') }}
								<input v-model="registerForm.first_name"
								       class="login-form-grey"
                       v-validate="'required|min:2|max:100'"
								       :class="{'is-danger': errors.has('first_name') }"
								       type="text"
								       name="first_name"
								       placeholder="Василий"
								       required>
                <span v-show="errors.has('first_name')" class="danger-message">{{ errors.first('first_name') }}</span>
							</label>
							<label class="login-label">{{ $t('surname') }}
								<input v-model="registerForm.surname"
								       class="login-form-grey"
                       v-validate="'min:2|max:100'"
								       :class="{'is-danger': errors.has('surname') }"
								       type="text"
								       name="surname"
								       placeholder="Александрович">
                <span v-show="errors.has('surname')" class="danger-message">{{ errors.first('surname') }}</span>
							</label>
							<label class="login-label" for="specialty">
                {{ $t('specialization') }}
                <v-select v-model="registerForm.specialization"
                          class="registry-form__form-specialty-input login-form-grey"
                          name="specialization"
                          v-validate="'required|min:2|max:100'"
                          :class="{'is-danger': errors.has('specialization') }"
                          id="specialty"
                          required
                          :options="specializations"></v-select>
                <span v-show="errors.has('specialization')" class="danger-message">{{ errors.first('specialization') }}</span>
              </label>


							<div class="registry-form__flex-container">
								<button class="registry-form__form-previous" type="button" value="previous-page" @click.prevent="prevStep()">Назад</button>
								<button class="registry-form__form-next" :disabled="checkStep1" type="button" value="next-page" @click.prevent="nextStep()">Далее</button>
							</div>
						</section>
					</section>

					<section class="registry-slide__contacts" v-show="registerSlide == 2">
						<h3 class="visually-hidden">Форма регистрации, третий слайд</h3>
						<section class="registry-form-slogan">
							<h4 class="visually-hidden">Контакты</h4>
							<div class="entry-form-header">
								<img src="/images/ui/modal-entry/entry-form-header-logo.png" width="62" height="62" alt="Эмблема школы">
								<h6>Школа<br> перинатальной медицины и <br>репродуктивного здоровья</h6>
							</div>
							<img class="registry-form-slogan__back" src="/images/ui/modal-entry/back-registry-slogan-mail.png" width="108" height="82" alt="Изображение конверта">
							<p class="registry-form-slogan__slogan">Контакты</p>
							<ul class="registry-form-slogan__switcher-indicator">
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
								<li class="registry-form-slogan__switcher-indicator-active"></li>
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
							</ul>
						</section>
						<section class="registry-form registry-form--contacts">
							<h4 class="visually-hidden">Поля формы регистрации</h4>
							<label class="login-label">{{ $t('email') }}
								<input class="login-form-grey"
								       v-model="registerForm.email"
                       v-validate="'required|email'"
								       :class="{'is-danger': errors.has('email') }"
								       type="email"
								       name="email"
								       placeholder="example@mail.com"
								       required />
                 <span v-show="errors.has('email')" class="danger-message">{{ errors.first('email') }}</span>
							</label>
							<label class="login-label">{{ $t('phone') }}
								<masked-input class="login-form-grey"
								       v-model="registerForm.phone"
                       v-validate="'required'"
								       :class="{'is-danger': errors.has('phone') }"
								       type="tel"
								       name="phone"
								       mask="\+\7 (111) 111-11-11"
								       placeholder="+7 (        )         -       -     "
								       required />
                 <span v-show="errors.has('phone')" class="danger-message">{{ errors.first('phone') }}</span>
							</label>
							<label class="login-label">{{ $t('password') }}
								<input class="login-form-grey"
								       v-model="registerForm.password"
                       v-validate="'required|confirmed:password_confirmation|min:6'"
								       :class="{'is-danger': errors.has('password') }"
								       type="password"
								       name="password"
								       placeholder="********"
								       required>
                 <span v-show="errors.has('password')" class="danger-message">{{ errors.first('password') }}</span>
							</label>
							<label class="login-label">{{ $t('confirm_password') }}
								<input class="login-form-grey"
								       v-model="registerForm.password_confirmation"
								       :class="{'is-danger': errors.has('password_confirmation') }"
								       type="password"
								       name="password_confirmation"
								       placeholder="********"
								       required>
                 <span v-show="errors.has('password_confirmation')" class="danger-message">{{ errors.first('password_confirmation') }}</span>
							</label>
							<div class="registry-form__flex-container">
								<button class="registry-form__form-previous" type="button" value="previous-page" @click.prevent="prevStep()">Назад</button>
								<button class="registry-form__form-next" :disabled="checkStep2" type="button" value="next-page" @click.prevent="nextStep()">Далее</button>
							</div>
						</section>
					</section>

					<section class="registry-slide__user-agreement" v-show="registerSlide == 3">
						<h3 class="visually-hidden">Форма регистрации, четвертый слайд</h3>
						<section class="registry-form-slogan">
							<h4 class="visually-hidden">Пользовательское соглашение</h4>
							<div class="entry-form-header">
								<img src="/images/ui/modal-entry/entry-form-header-logo.png" width="62" height="62" alt="Эмблема школы">
								<h6>Школа<br> перинатальной медицины и <br>репродуктивного здоровья</h6>
							</div>
							<img class="registry-form-slogan__back" src="/images/ui/modal-entry/back-registry-slogan-contract.png" width="139" height="182" alt="Изображение договора">
							<p class="registry-form-slogan__slogan">Пользовательское<br> соглашение</p>
							<ul class="registry-form-slogan__switcher-indicator">
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
								<li class="registry-form-slogan__switcher-indicator-inactive"></li>
								<li class="registry-form-slogan__switcher-indicator-active"></li>
							</ul>
						</section>
						<section class="registry-form registry-form--user-agreement">
							<h4 class="visually-hidden">Текст соглашения</h4>
							<label class="login-label">{{ $t('agreement') }}
								<textarea class="registry-form__form-agreement-text login-form-grey" readonly>{{ agreement }}</textarea>
							</label>
							<input class="visually-hidden checkbox-agree" type="checkbox"
                     v-validate="'required'"
							       name="agree" id="agree" v-model="registerForm.agreed">
							<label class="registry-form__form-checkbox-agree login-form-grey" for="agree">{{ registerForm.agreed ? $t('accepted') : $t('accept') }}</label>
              <div class="registry-form__flex-container">
								<button class="registry-form__form-previous" type="button" value="previous-page" @click.prevent="prevStep()">Назад</button>
                <input class="registry-form__form-sign-up"
                       :disabled="registerForm.busy || !registerFormIsCorrect"
                       type="submit" value="Зарегистрироваться">
							</div>

						</section>
					</section>
				</form>
			</article>
		</article>
  </modal>
</template>
<script>
    import Modal from './global/Modal'
    import MaskedInput from 'vue-masked-input'
    import Form from 'vform'
    import axios from 'axios'
    import { Validator } from 'vee-validate';
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    // The Vue Modal component
    export default {
      name: 'UniversalModal',
      components: {
        Modal,
        MaskedInput,
        vSelect
      },
      props: [
        'show'
      ],
      watch: {
        // 'registerForm.city': function(query) {
        //   this.getCitySuggestions(query);
        // },
        'registerForm.specialization': function(query) {
          this.getSpecializationSuggestions(query);
        },
      },
      data: () => ({
        modalTypeOption: 'login',
        registerSlide: 0,
        registerErrors: {},
        loginError: false,
        specializations: [],
        countries: [],
        loginForm: new Form({
          email: '',
          password: ''
        }),
        remember: true,
        changePasswordMode: false,
        changePasswordSuccess: false,
        changePasswordFailure: false,
        citySuggestions: [],
        countrySuggestions: [],

        registerForm: new Form({
          first_name: '',
          second_name: '',
          surname: '',
          email: '',
          city: '',
          country: '',
          phone: '',
          organization: '',
          specialization: 'Не указана',
          password: '',
          password_confirmation: '',
          agreed: false,
        })
      }),
      methods: {
        async register () {
          // Register the user.
          const { data } = await this.registerForm.post('/api/register');

          this.close();
          this.$router.push({ name: 'register.confirmation' })
        },
        async login () {
          this.loginError = false;
          // Submit the form.
          if (this.changePasswordMode) {
            console.log('change password', this.loginForm);
            const {data} = await this.loginForm.post('/api/password/email');
            this.close();

            this.$router.push({ name: 'password.linkSent' })
          } else {
            try {
              const {data} = await this.loginForm.post('/api/login');

              // Save the token.
              this.$store.dispatch('auth/saveToken', {
                token: data.token,
                remember: this.remember
              });

              this.close();

              // Fetch the user.
              await this.$store.dispatch('auth/fetchUser');
            } catch (e) {
              this.loginError = true;
            }
          }
        },
        close: function () {
          this.loginForm.reset();
          this.registerForm.reset();
          this.$emit('close');
        },
        selectCity(city) {
          this.registerForm.city = city;
          this.citySuggestions = [];
        },

        showLogin() {
          this.modalTypeOption = 'login';
          this.registerSlide = 0;
          this.changeModalType();
        },
        nextStep() {
          this.registerSlide++;
        },
        prevStep() {
          this.registerSlide--;
        },
        changeModalType () {
          if (this.modalTypeOption === 'login') {
            this.$store.dispatch('modals/showLogin');
          } else {
            this.$store.dispatch('modals/showRegister');
          }
        },
        async getCitySuggestions(query, loading) {
          loading(true);
          const { data } = await axios.post('/api/dadata/city', {
            query: query
          });
          this.citySuggestions = data.filter((elem, pos, arr) => {
            return arr.indexOf(elem) == pos && elem;
          });
          loading(false);
        },
        onBlur() {
          this.citySuggestions = [];
          this.countrySuggestions = [];
        }
      },
      computed: {
        filteredSpecializations: function () {
          return this.registerForm.specialization ? this.specializations.filter(s => s.indexOf(this.registerForm.specialization) !== -1) : this.specializations;
        },
        registerFormIsCorrect: function () {

          let canRegister = true;
          for (let field in this.registerForm.originalData) {
            if (!this.registerForm[field]) {
              if (field !== 'surname') {
                canRegister = false;
              }
            }
          }
          return canRegister;
        },
        checkStep0: function () {
          return !this.registerForm.city || !this.registerForm.country || !this.registerForm.organization;
        },
        checkStep1: function () {
          return !this.registerForm.first_name || !this.registerForm.second_name || !this.registerForm.specialization;
        },
        checkStep2: function () {
          return !this.registerForm.email || !this.registerForm.password
            || !this.registerForm.password_confirmation || !this.registerForm.phone;
        },
        modalType: function() {
          return this.$store.getters['modals/modalType']
        },
        agreement: function() {
          return this.$store.getters['common/agreement']
        },
        vkAuth: () => window.config.vkAuth,
        facebookAuth: () => window.config.facebookAuth,
        twitterAuth: () => window.config.twitterAuth,
        odnoklassnikiAuth: () => window.config.odnoklassnikiAuth,
        githubAuth: () => window.config.githubAuth,
      },
      mounted: async function () {
        document.addEventListener("keydown", e => {
          if (this.show && e.keyCode == 27) {
            this.close();
          }
        });

        const { data } = await axios.get('/api/specializations');
        this.specializations = data;

        await this.getCitySuggestions('', () => false);
      },
    };
</script>

